export const SAISIE_OBLIGATOIRE = 'Saisie obligatoire'
export const SAISIE_INVALIDE = 'Saisie invalide'
export const SAISIE_DATE_INVALIDE = 'Saisissez une valeur de date valide au format JJ/MM/AAAA'
export const SAISIE_EMAIL_INVALIDE = 'Respecter le format de l’Email'
